import {
  ApresentacaoFetal,
  PosicaoFetal,
  MovimentoFetal,
  Edema,
  Egb,
  EscolaridadePaciente,
  EstadoCivilPaciente,
  EstadosBrasil,
  SexoBebe,
  SimNao,
  SimNaoNaoSei,
  StatusExame,
  TipoHistorico,
  TipoTelefone,
  TipoConsulta,
  TipoParto,
  NormalAlterado,
  PlacentaLocalizacao,
  TipoNotaProntuario,
} from '../../../back/src/types';

// Apresentação fetal

export const apresentacaoFetalItems = [
  { value: ApresentacaoFetal.C, text: 'Cefálico' },
  { value: ApresentacaoFetal.P, text: 'Pélvico' },
  { value: ApresentacaoFetal.T, text: 'Transversa' },
  { value: ApresentacaoFetal.X, text: 'Indefinido' },
];

export const apresentacaoFetalStrings = {
  C: 'Cefálico',
  P: 'Pélvico',
  T: 'Transversa',
  X: 'Indefinido',
};

// Posição fetal

export const posicaoFetalItems = [
  { value: PosicaoFetal.D, text: 'Direita' },
  { value: PosicaoFetal.E, text: 'Esquerda' },
  { value: PosicaoFetal.A, text: 'Anterior' },
  { value: PosicaoFetal.P, text: 'Posterior' },
  { value: PosicaoFetal.X, text: 'Indefinido' },
];

export const posicaoFetalStrings = {
  D: 'Direita',
  E: 'Esquerda',
  A: 'Anterior',
  P: 'Posterior',
  X: 'Indefinido',
};

// Movimento fetal

export const movimentoFetalItems = [
  { value: MovimentoFetal.P, text: 'Positivo' },
  { value: MovimentoFetal.N, text: 'Negativo' },
  { value: MovimentoFetal.I, text: 'Indetectável' },
];

export const movimentoFetalStrings = {
  P: 'Positivo',
  N: 'Negativo',
  I: 'Indetectável',
};

// Edema

export const edemaItems = [
  { value: Edema['1+'], text: '1+' },
  { value: Edema['2+'], text: '2+' },
  { value: Edema['3+'], text: '3+' },
  { value: Edema['4+'], text: '4+' },
];

export const edemaStrings = {
  '1+': '1+',
  '2+': '2+',
  '3+': '3+',
  '4+': '4+',
};

// EGB

export const egbItems = [
  { value: Egb.P, text: 'Positivo' },
  { value: Egb.N, text: 'Negativo' },
  { value: Egb.X, text: 'Desconhecido' },
];

export const egbStrings = {
  P: 'Positivo',
  N: 'Negativo',
  X: 'Desconhecido',
};

export const egbAbrev = {
  P: 'Pos.',
  N: 'Neg.',
  X: 'Desc.',
};

// Escolaridade

export const escolaridadeItems = [
  { value: EscolaridadePaciente.EFI, text: 'Ensino fundamental incompleto' },
  { value: EscolaridadePaciente.EFC, text: 'Ensino fundamental completo' },
  { value: EscolaridadePaciente.EMI, text: 'Ensino médio incompleto' },
  { value: EscolaridadePaciente.EMC, text: 'Ensino médio completo' },
  { value: EscolaridadePaciente.ESI, text: 'Ensino superior incompleto' },
  { value: EscolaridadePaciente.ESC, text: 'Ensino superior completo' },
];
export const escolaridadeStrings = {
  EFI: 'Ensino fundamental incompleto',
  EFC: 'Ensino fundamental completo',
  EMI: 'Ensino médio incompleto',
  EMC: 'Ensino médio completo',
  ESI: 'Ensino superior incompleto',
  ESC: 'Ensino superior completo',
};

// EstadoCivilPaciente

export const estadoCivilItems = [
  { value: EstadoCivilPaciente.S, text: 'Solteira' },
  { value: EstadoCivilPaciente.C, text: 'Casada' },
  { value: EstadoCivilPaciente.U, text: 'União Estável' },
  { value: EstadoCivilPaciente.O, text: 'Outro' },
];

export const estadoCivilStrings = {
  S: 'Solteira',
  C: 'Casada',
  U: 'União Estável',
  O: 'Outro',
};

// EstadosBrasil

export const estadosBrasilItems = [
  { value: EstadosBrasil.AC, text: 'Acre' },
  { value: EstadosBrasil.AL, text: 'Alagoas' },
  { value: EstadosBrasil.AP, text: 'Amapá' },
  { value: EstadosBrasil.AM, text: 'Amazonas' },
  { value: EstadosBrasil.BA, text: 'Bahia' },
  { value: EstadosBrasil.CE, text: 'Ceará' },
  { value: EstadosBrasil.DF, text: 'Distrito Federal' },
  { value: EstadosBrasil.ES, text: 'Espírito Santo' },
  { value: EstadosBrasil.GO, text: 'Goiás' },
  { value: EstadosBrasil.MA, text: 'Maranhão' },
  { value: EstadosBrasil.MT, text: 'Mato Grosso' },
  { value: EstadosBrasil.MS, text: 'Mato Grosso do Sul' },
  { value: EstadosBrasil.MG, text: 'Minas Gerais' },
  { value: EstadosBrasil.PA, text: 'Pará' },
  { value: EstadosBrasil.PB, text: 'Paraíba' },
  { value: EstadosBrasil.PR, text: 'Paraná' },
  { value: EstadosBrasil.PE, text: 'Pernambuco' },
  { value: EstadosBrasil.PI, text: 'Piauí' },
  { value: EstadosBrasil.RJ, text: 'Rio de Janeiro' },
  { value: EstadosBrasil.RN, text: 'Rio Grande do Norte' },
  { value: EstadosBrasil.RS, text: 'Rio Grande do Sul' },
  { value: EstadosBrasil.RO, text: 'Rondônia' },
  { value: EstadosBrasil.RR, text: 'Roraima' },
  { value: EstadosBrasil.SC, text: 'Santa Catarina' },
  { value: EstadosBrasil.SP, text: 'São Paulo' },
  { value: EstadosBrasil.SE, text: 'Sergipe' },
  { value: EstadosBrasil.TO, text: 'Tocantins' },
  { value: EstadosBrasil.EX, text: 'Estrangeiro' },
];

export const estadosBrasilStrings = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins',
  EX: 'Estrangeiro',
};

// SexoBebe

export const sexoBebeIcons = {
  F: 'fa-fw fa-venus',
  M: 'fa-fw fa-mars',
  S: 'fa-fw fa-gift',
  X: 'fa-fw fa-question',
};

export const sexoBebeItens = [
  { value: SexoBebe.F, text: 'Feminino' },
  { value: SexoBebe.M, text: 'Masculino' },
  { value: SexoBebe.S, text: 'Surpresa' },
  { value: SexoBebe.X, text: 'Indefinido' },
];

export const sexoBebeItensFinalizar = [
  { value: SexoBebe.F, text: 'Feminino' },
  { value: SexoBebe.M, text: 'Masculino' },
];

export const sexoBebeStrings = {
  F: 'Feminino',
  M: 'Masculino',
  S: 'Surpresa',
  X: 'Indefinido',
};

// SimNao

export const simNaoItens = [
  { value: SimNao.S, text: 'Sim' },
  { value: SimNao.N, text: 'Não' },
];

export const simNaoStrings = {
  S: 'Sim',
  N: 'Não',
};

// SimNaoNaosei

export const simNaoNaoSeiItens = [
  { value: SimNaoNaoSei.S, text: 'Sim' },
  { value: SimNaoNaoSei.N, text: 'Não' },
  { value: SimNaoNaoSei.X, text: 'Não sei' },
];

export const simNaoNaoSeiStrings = {
  S: 'Sim',
  N: 'Não',
  X: 'Não sei',
};

export const simNaoNaoSabeItens = [
  { value: SimNaoNaoSei.S, text: 'Sim' },
  { value: SimNaoNaoSei.N, text: 'Não' },
  { value: SimNaoNaoSei.X, text: 'Não sabe' },
];

export const simNaoNaoSabeStrings = {
  S: 'Sim',
  N: 'Não',
  X: 'Não sabe',
};

// TipoConsulta

export const tipoConsultaIcons = {
  P: 'fa-fw fa-stethoscope',
  R: 'fa-fw fa-phone-alt',
};

export const tipoNotaProntuarioIcons = {
  NE: 'fa-notes-medical',
  CR: 'fa-phone-alt',
  RP: 'fa-glasses',
};

export const tipoConsultaItens = [
  { value: TipoConsulta.P, text: 'Presencial' },
  { value: TipoConsulta.R, text: 'Remota' },
];

export const tipoConsultaStrings = {
  P: 'Presencial',
  R: 'Remota',
};

// TipoHistorico

export const tipoHistoricoItens = [
  { value: TipoHistorico.F, text: 'Familiar' },
  { value: TipoHistorico.G, text: 'Ginecológico' },
  { value: TipoHistorico.H, text: 'Hábitos' },
  { value: TipoHistorico.P, text: 'Pessoal' },
];

export const tipoHistoricoStrings = {
  F: 'Familiar',
  G: 'Ginecológico',
  H: 'Hábitos',
  P: 'Pessoal',
};

// TipoNotasProntuario
export const tipoNotasProntuarioStrings = {
  NE: 'Nota de exames',
  CR: 'Consulta remota',
  RP: 'Revisão de prontuário',
};

// TipoParto

export const tipoPartoItens = [
  { value: TipoParto.N, text: 'Parto Normal' },
  { value: TipoParto.C, text: 'Cesárea' },
  { value: TipoParto.A, text: 'Aborto' },
];

export const tipoPartoStrings = {
  N: 'Parto Normal',
  C: 'Cesárea',
  A: 'Aborto',
};

// TipoTelefone

export const tipoTelefoneIcons = {
  W: 'fab fa-whatsapp',
  C: 'fa-mobile-alt',
  F: 'fa-phone-alt',
};

export const tipoTelefoneItems = [
  { value: TipoTelefone.W, text: 'WhatsApp' },
  { value: TipoTelefone.C, text: 'Celular' },
  { value: TipoTelefone.F, text: 'Fixo' },
];

export const tipoTelefoneStrings = {
  W: 'WhatsApp',
  C: 'Celular',
  F: 'Fixo',
};

// Flags e avisos das gestações
export const avisosGestacao = {
  MS: {
    sigla: 'MS',
    descricao: 'Mãe solo',
    color: 'info',
  },
  GG: {
    sigla: 'GG',
    descricao: 'Gestação gemelar',
    color: 'info',
  },
  PA: {
    sigla: 'PA',
    descricao: 'Pressão arterial',
    color: 'pink',
  },
  DG: {
    sigla: 'DG',
    descricao: 'Diabetes gestacional',
    color: 'purple',
  },
  RC: {
    sigla: 'RC',
    descricao: 'Restrição de crescimento',
    color: 'indigo',
  },
  HG: {
    sigla: 'HG',
    descricao: 'Herpes genital',
    color: 'blue',
  },
  RH: {
    sigla: 'RH',
    descricao: 'Rh negativo',
    color: 'cyan',
  },
  AR: {
    sigla: 'AR',
    descricao: 'Alto risco - variados',
    color: 'red',
  },
  HT: {
    sigla: 'HT',
    descricao: 'Hipotireoidismo',
    color: 'orange',
  },
  TF: {
    sigla: 'TF',
    descricao: 'Trombofilia',
    color: 'brown',
  },
};

// Status exames

export const statusExameItems = [
  { value: StatusExame['+'], text: 'Positivo' },
  { value: StatusExame['-'], text: 'Negativo' },
  { value: StatusExame.I, text: 'Imune' },
  { value: StatusExame.A, text: 'Alterado' },
  { value: StatusExame.N, text: 'Normal' },
  { value: StatusExame.S, text: 'Solicitado' },
];

export const statusExameStrings = {
  '+': 'Positivo',
  '-': 'Negativo',
  I: 'Imune',
  A: 'Alterado',
  N: 'Normal',
  S: 'Solicitado',
};

// Normal e alterado

export const normalAlteradoItens = [
  { value: NormalAlterado.N, text: 'Normal' },
  { value: NormalAlterado.A, text: 'Alterado' },
];

export const normalAlteradoStrings = {
  N: 'Normal',
  A: 'Alterado',
};

// Localizacao placenta
export const placentaLocalizacaoItens = [
  { value: PlacentaLocalizacao.A, text: 'Anterior' },
  { value: PlacentaLocalizacao.P, text: 'Posterior' },
  { value: PlacentaLocalizacao.L, text: 'Lateral' },
  { value: PlacentaLocalizacao.F, text: 'Fúndica' },
  { value: PlacentaLocalizacao.V, text: 'Prévia' },
];

export const placentaLocalizacaoStrings = {
  A: 'Anterior',
  P: 'Posterior',
  L: 'Lateral',
  F: 'Fúndica',
  V: 'Prévia',
};

// Locais de parto
export const localPartoLowerValues = {
  'casa de parto': 'Casa de Parto',
  'casade parto': 'Casa de Parto',
  'casa departo': 'Casa de Parto',
  casadeparto: 'Casa de Parto',
  domicilio: 'Domicílio',
  domicílio: 'Domicílio',
  'hospital são luiz': 'São Luiz',
  'hospital sao luiz': 'São Luiz',
  'hospitalsão luiz': 'São Luiz',
  'hospitalsao luiz': 'São Luiz',
  'hospital sãoluiz': 'São Luiz',
  'hospital saoluiz': 'São Luiz',
  hospitalsãoluiz: 'São Luiz',
  hospitalsaoluiz: 'São Luiz',
  'são luiz': 'São Luiz',
  'sao luiz': 'São Luiz',
  sãoluiz: 'São Luiz',
  saoluiz: 'São Luiz',
  sepaco: 'Sepaco',
};

export const localPartoItens = [
  { value: 'Casa de Parto', text: 'Casa de Parto' },
  { value: 'Domicílio', text: 'Domicílio' },
  { value: 'São Luiz', text: 'São Luiz' },
  { value: 'Sepaco', text: 'Sepaco' },
  { value: 'outro', text: 'Outro...' },
];

// Parto na água
export const partoAguaItens = [
  { value: 'Banheira', text: 'Banheira' },
  { value: 'Chuveiro', text: 'Chuveiro' },
  { value: "Fora d'água", text: "Fora d'água" },
];

// Posições de parto
export const posicoesPartoItens = [
  { value: 'Semi sentada na banheira', text: 'Semi sentada na banheira' },
  { value: 'Semi sentada na cama', text: 'Semi sentada na cama' },
  { value: 'Sentada na banqueta', text: 'Sentada na banqueta' },
  { value: 'Cócoras SEM banqueta', text: 'Cócoras SEM banqueta' },
  { value: 'Quatro apoios', text: 'Quatro apoios' },
  { value: 'Ajoelhada', text: 'Ajoelhada' },
  { value: 'Deitada de lado', text: 'Deitada de lado' },
  { value: 'Em pé', text: 'Em pé' },
  { value: 'Litotomia', text: 'Litotomia' },
  { value: 'Outra', text: 'Outra' },
];

// Ruptura da bolsa
export const rupturaBolsaItens = [
  { value: 'Espontânea fora de TP', text: 'Espontânea fora de TP' },
  { value: 'Espontânea no início do TP', text: 'Espontânea no início do TP' },
  { value: 'Espontânea no fim do TP ou expulsivo', text: 'Espontânea no fim do TP ou expulsivo' },
  { value: 'Nasceu empelicado', text: 'Nasceu empelicado' },
  { value: 'Artificial', text: 'Artificial' },
  { value: 'Ignorado', text: 'Ignorado' },
];

// Tempo de período expulsivo
export const periodoExpulsivoItens = [
  { value: '< 30min', text: '< 30min' },
  { value: '30min a 1h', text: '30min a 1h' },
  { value: '1h a 2h', text: '1h a 2h' },
  { value: '2h a 3h', text: '2h a 3h' },
  { value: '3 a 4h', text: '3 a 4h' },
  { value: '4 a 5h', text: '4 a 5h' },
];

// Manobra para dequitação de placenta
export const manobraDequitacaoItens = [
  { value: 'Dequitação expontânea', text: 'Dequitação expontânea' },
  { value: 'Tração controlada com massagem uterina', text: 'Tração controlada com massagem uterina' },
  { value: 'Ocitocina no cordão umbilical', text: 'Ocitocina no cordão umbilical' },
  { value: 'Curagem ou curetagem', text: 'Curagem ou curetagem' },
];

// Sangramento pós parto
export const sangramentoPosPartoItens = [
  { value: 'Normal', text: 'Normal' },
  { value: 'Aumentado mas sem sintomas', text: 'Aumentado mas sem sintomas' },
  { value: 'Aumentado e com sintomas', text: 'Aumentado e com sintomas' },
];

// Indicação de cesárea
export const indicacaoCesareaItens = [
  { value: 'Pélvico', text: 'Pélvico' },
  { value: 'Desproporção céfalo pélvica', text: 'Desproporção céfalo pélvica' },
  { value: 'Frequência cardíaca fetal não tranquilizadora', text: 'Frequência cardíaca fetal não tranquilizadora' },
  { value: 'Pedido materno', text: 'Pedido materno' },
  { value: 'Falha de indução', text: 'Falha de indução' },
  { value: 'Prolapso de cordão', text: 'Prolapso de cordão' },
  { value: 'Descolamento de placenta', text: 'Descolamento de placenta' },
  { value: 'Pré eclâmpsia com piora do quadro', text: 'Pré eclâmpsia com piora do quadro' },
  { value: 'Outro', text: 'Outro' },
];

// HPP (Hemorragia pós parto) - quantidade
export const hppQuantidadeItens = [
  { value: 'Entre 500 e 800 ml', text: 'Entre 500 e 800 ml' },
  { value: 'Entre 800 e 1200 ml', text: 'Entre 800 e 1200 ml' },
  { value: 'Entre 1200 e 2000 ml', text: 'Entre 1200 e 2000 ml' },
  { value: 'Mais de 2000 ml', text: 'Mais de 2000 ml' },
];

// Clampeamento de cordão umbilical
export const clampeamentoItens = [
  { value: 'Mais que 10 minutos', text: 'Mais que 10 minutos' },
  { value: 'Entre 3 e 10 minutos', text: 'Entre 3 e 10 minutos' },
  { value: 'Entre 1 e 3 minutos', text: 'Entre 1 e 3 minutos' },
  { value: 'Antes de 1 minuto ou imediato', text: 'Antes de 1 minuto ou imediato' },
];

// Tempo da amamentação
export const amamentacaoItens = [
  { value: '1ª hora de vida', text: '1ª hora de vida' },
  { value: '2ª hora de vida', text: '2ª hora de vida' },
  { value: 'Outro', text: 'Outro' },
];

// Encaminhamento Recem nascido
export const encaminhamentoRnItens = [
  { value: 'Alojamento Conjunto', text: 'Alojamento Conjunto' },
  { value: 'Berçário', text: 'Berçário' },
  { value: 'UTI Neonatal', text: 'UTI Neonatal' },
];


// Internacoes Locais
export const internacaoLocalItens = localPartoItens;

// Internacoes Motivos
export const internacaoMotivoItens = [
  { value: 'Trabalho de parto', text: 'Trabalho de parto' },
  { value: 'Indução por hipertensão', text: 'Indução por hipertensão' },
  { value: 'Indução por RCIU', text: 'Indução por RCIU' },
  { value: 'Indução por BR', text: 'Indução por BR' },
  { value: 'Indução por DG', text: 'Indução por DG' },
  { value: 'Indução por pós datismo', text: 'Indução por pós datismo' },
  { value: 'VCE', text: 'VCE' },
  { value: 'outro', text: 'Outro...' },
];

export const awsS3URL = process.env.VUE_APP_AWS_S3_URL || 'https://kemiocode.s3-sa-east-1.amazonaws.com/';

// Momentos medições glicemia items
export const momentosMedicoesGlicemiaItems = [
  { value: 'JE', text: 'Jejum' },
  { value: 'PC', text: 'Pós café da manhã' },
  { value: 'PA', text: 'Pós almoço' },
  { value: 'PJ', text: 'Pós jantar' },
  { value: 'AV', text: 'Avulso' },
];


export const periodosMedicoesPressaoArterialItems = [
  { value: 'M', text: 'Manhã' },
  { value: 'T', text: 'Tarde' },
  { value: 'N', text: 'Noite' },
];

export const posicoesMedicoesPressaoArterialItems = [
  { value: 'S', text: 'Sentada' },
  { value: 'D', text: 'Decúbito L.E.' },
];

export const momentosMedicoesPressaoItems = [
  { value: 'MS', text: 'Manhã - Sentada' },
  { value: 'MD', text: 'Manhã - Decúbito L.E.' },
  { value: 'TS', text: 'Tarde - Sentada' },
  { value: 'TD', text: 'Tarde - Decúbito L.E.' },
  { value: 'NS', text: 'Noite - Sentada' },
  { value: 'ND', text: 'Noite - Decúbito L.E.' },
];

export const tiposNotasProntuarioItems = [
  { value: TipoNotaProntuario.CONSULTA_REMOTA, text: 'Consulta remota' },
  { value: TipoNotaProntuario.NOTA_EXAME, text: 'Nota de exame' },
  { value: TipoNotaProntuario.REVISAO_PRONTUARIO, text: 'Revisão de prontuário' },
];

export const momentosMedicoesGlicemiaStrings = {
  JE: 'Jejum',
  PC: 'Pós café da manhã',
  PA: 'Pós almoço',
  PJ: 'Pós jantar',
  AV: 'Avulso',
};

export const periodosMedicoesPressaoStrings = {
  M: 'Manhã',
  T: 'Tarde',
  N: 'Noite',
};

export const posturasMedicoesPressaoStrings = {
  S: 'Sentada',
  D: 'Decúbito L.E.',
};

export const gruposIds = {
  ADMINISTRATIVO: 1,
  FINANCEIRO: 2,
  RECEPÇÃO: 3,
  DIREÇÃO: 4,
  MÉDICAS: 5,
  OBSTETRIZES: 6,
  PACIENTES: 7,
};

export const gruposIdsUsuariosInternos: number[] = [
  gruposIds.ADMINISTRATIVO,
  gruposIds.FINANCEIRO,
  gruposIds.RECEPÇÃO,
  gruposIds.DIREÇÃO,
  gruposIds.MÉDICAS,
  gruposIds.OBSTETRIZES,
];

export const tiposMedicoes = {
  GLICEMIA: 'G',
  PRESSAO: 'P',
};
